module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEABAMAAACuXLVVAAAAG1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAKkTAO0UW9jFsMAAAAB3RSTlMADQ4PEBESsu+mmQAAANRJREFUeF7swAEJAAAAwjD7pzbHYVsVAAAAAAAAAAAAAAAAAAAAAADwdu0YhYEQCKAoW3mEtOnS5ig5ioQQ9wZ67NQqpHBhYJf32ynmlSqm0pWjAdveuuorGHBrQ99gwD4Caiwgtal8TQAAAAAAAAAAAAAAAAAAAEDpytGArbSu+owFzA9Bn2DA/BAUA/i35ZoAAAAAAACA0hUMmI895R4MeLShdzBgPvYEAxa2BAMAAAAAAAAAAAAAAAAAAOKv54uj0wLSIKj52Oj4J+3F0WmTJEmSft3JJpaVEt2TAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/signal-3.png
// module id = 1166
// module chunks = 0